import { render } from "./DocumentTagCard.vue?vue&type=template&id=339afcd6"
import script from "./DocumentTagCard.vue?vue&type=script&lang=js"
export * from "./DocumentTagCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__